import { IEntity } from "./Entity";
import { Entity } from "./Entity";

export interface ICLDefApprover extends IEntity {
    CustomerID?: number;

    Approver1?: string;
    Approver1FrameworkID?: number;
    Approver1FrameworkCriteria?: string;
    Approver1UserRequired?: string;

    Approver2?: string;
    Approver2FrameworkID?: number;
    Approver2FrameworkCriteria?: string;
    Approver2UserRequired?: string;

    Approver3?: string;
    Approver3FrameworkID?: number;
    Approver3FrameworkCriteria?: string;
    Approver3UserRequired?: string;

    Approver4?: string;
    Approver4FrameworkID?: number;
    Approver4FrameworkCriteria?: string;
    Approver4UserRequired?: string;

    Approver5?: string;
    Approver5FrameworkID?: number;
    Approver5FrameworkCriteria?: string;
    Approver5UserRequired?: string;

    Approver6?: string;
    Approver6FrameworkID?: number;
    Approver6FrameworkCriteria?: string;
    Approver6UserRequired?: string;
}

export class CLDefApprover extends Entity implements ICLDefApprover {
    public CustomerID: number = null;

    public Approver1: string = "";
    public Approver1FrameworkID: number = null;
    public Approver1FrameworkCriteria: string = "";
    public Approver1UserRequired: string = "";

    public Approver2: string = "";
    public Approver2FrameworkID: number = null;
    public Approver2FrameworkCriteria: string = "";
    public Approver2UserRequired: string = "";

    public Approver3: string = "";
    public Approver3FrameworkID: number = null;
    public Approver3FrameworkCriteria: string = "";
    public Approver3UserRequired: string = "";

    public Approver4: string = "";
    public Approver4FrameworkID: number = null;
    public Approver4FrameworkCriteria: string = "";
    public Approver4UserRequired: string = "";

    public Approver5: string = "";
    public Approver5FrameworkID: number = null;
    public Approver5FrameworkCriteria: string = "";
    public Approver5UserRequired: string = "";

    public Approver6: string = "";
    public Approver6FrameworkID: number = null;
    public Approver6FrameworkCriteria: string = "";
    public Approver6UserRequired: string = "";

    constructor() {
        super();

        this.Approver1FrameworkID = null;
        this.Approver1FrameworkCriteria = 'All';
        this.Approver1UserRequired = 'Yes';

        this.Approver2FrameworkID = null;
        this.Approver2FrameworkCriteria = 'All';
        this.Approver2UserRequired = 'Yes';

        this.Approver3FrameworkID = null;
        this.Approver3FrameworkCriteria = 'All';
        this.Approver3UserRequired = 'Yes';

        this.Approver4FrameworkID = null;
        this.Approver4FrameworkCriteria = 'All';
        this.Approver4UserRequired = 'Yes';

        this.Approver5FrameworkID = null;
        this.Approver5FrameworkCriteria = 'All';
        this.Approver5UserRequired = 'Yes';

        this.Approver6FrameworkID = null;
        this.Approver6FrameworkCriteria = 'All';
        this.Approver6UserRequired = 'Yes';
    }

}
